import { useState, useEffect } from "react";
import { Modal, Button, Form, Table, Row, Col } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";

export default function Add_data_modal({
  select_data,
  open_update_data_modal,
  onUpdateType,
}) {
  const [update_modal_data, setUpdate_modal_data] = useState({
    company: "",
    vehiclename: "",
    vehicle_type: "",
    vehicleCategory: "",
    firstServiceKm: "",
    firstServiceDays: "",
    secondServiceKm: "",
    secondServiceDays: "",
    thirdServiceKm: "",
    thirdServiceDays: "",
    fixedServiceKm: "",
    fixedServiceDays: "",
    feet: "",
    battery: "",
    amount: "",
    oemDetails: [],
  });

  const [add_data_modal_Show, set_update_data_modal_Show] = useState(false);

  const [errors, setErrors] = useState({});

  // =====================================================
  // LOAD DATA WHEN SELECTED VEHICLE CHANGES
  // =====================================================
  useEffect(() => {
    if (select_data) {
      setUpdate_modal_data({
        _id: select_data._id || "",

        company: select_data.company || "",

        vehiclename: select_data.vehiclename || "",

        vehicle_type: select_data.vehicle_type || "",

        vehicleCategory: select_data.vehicleCategory || "",

        firstServiceKm: select_data.firstServiceKm ?? "",

        firstServiceDays: select_data.firstServiceDays ?? "",

        secondServiceKm: select_data.secondServiceKm ?? "",

        secondServiceDays: select_data.secondServiceDays ?? "",

        thirdServiceKm: select_data.thirdServiceKm ?? "",

        thirdServiceDays: select_data.thirdServiceDays ?? "",

        fixedServiceKm: select_data.fixedServiceKm ?? "",

        fixedServiceDays: select_data.fixedServiceDays ?? "",

        feet: select_data.feet ?? "",

        battery: select_data.battery ?? "",

        amount: select_data.amount ?? "",

        // OEM DETAILS
        oemDetails: Array.isArray(select_data.oemDetails)
          ? select_data.oemDetails.map((oem) => ({
              _id: oem._id || "",

              name: oem.name || oem.Name || "",

              contact: oem.contact || oem.Contact || "",

              email: oem.email || oem.Email || "",
            }))
          : [],
      });
    }
  }, [select_data]);

  // =====================================================
  // OPEN MODAL
  // =====================================================
  useEffect(() => {
    if (open_update_data_modal) {
      set_update_data_modal_Show(open_update_data_modal.modal_open || false);
    }
  }, [open_update_data_modal]);

  // =====================================================
  // CLOSE MODAL
  // =====================================================
  const handleClose = () => {
    set_update_data_modal_Show(false);
    setErrors({});
  };

  // =====================================================
  // HANDLE VEHICLE FIELD CHANGE
  // =====================================================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setUpdate_modal_data((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Remove error when user changes field
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // =====================================================
  // HANDLE OEM FIELD CHANGE
  // =====================================================
  const handleOEMChange = (index, e) => {
    const { name, value } = e.target;

    setUpdate_modal_data((prev) => {
      const updatedOEMs = [...prev.oemDetails];

      updatedOEMs[index] = {
        ...updatedOEMs[index],
        [name]: value,
      };

      return {
        ...prev,
        oemDetails: updatedOEMs,
      };
    });

    setErrors((prev) => ({
      ...prev,
      [`oem_${index}_${name}`]: "",
    }));
  };

  // =====================================================
  // ADD OEM
  // =====================================================
  const addOEM = () => {
    setUpdate_modal_data((prev) => ({
      ...prev,
      oemDetails: [
        ...prev.oemDetails,
        {
          name: "",
          contact: "",
          email: "",
        },
      ],
    }));
  };

  // =====================================================
  // REMOVE OEM
  // =====================================================
  const removeOEM = (index) => {
    setUpdate_modal_data((prev) => ({
      ...prev,
      oemDetails: prev.oemDetails.filter((_, i) => i !== index),
    }));

    setErrors({});
  };

  // =====================================================
  // VALIDATE FORM
  // =====================================================
  const validateFields = () => {
    const newErrors = {};

    // Vehicle validation
    if (!update_modal_data.company?.trim()) {
      newErrors.company = "Company is required";
    }

    if (!update_modal_data.vehiclename?.trim()) {
      newErrors.vehiclename = "Vehicle Type is required";
    }

    if (!update_modal_data.vehicle_type) {
      newErrors.vehicle_type = "Wheeler Type Selection is required";
    }

    // OEM validation
    update_modal_data.oemDetails.forEach((oem, index) => {
      if (!oem.name?.trim()) {
        newErrors[`oem_${index}_name`] = "OEM Name is required";
      }

      if (!oem.contact?.trim()) {
        newErrors[`oem_${index}_contact`] = "Contact is required";
      }

      if (!oem.email?.trim()) {
        newErrors[`oem_${index}_email`] = "Email is required";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(oem.email)) {
        newErrors[`oem_${index}_email`] = "Enter a valid email";
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // =====================================================
  // UPDATE VEHICLE TYPE
  // =====================================================
  const handleUpdate = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      Swal.fire("Authentication Error", "Please login again.", "error");
      return;
    }

    // Validate
    if (!validateFields()) {
      Swal.fire(
        "Validation Error",
        "Please fill in all required fields.",
        "error",
      );
      return;
    }

    // Confirmation
    const result = await Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      text: "Do you want to update this vehicle type?",
      showCancelButton: true,
      confirmButtonText: "Yes, Update",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      const id = update_modal_data._id;

      if (!id) {
        Swal.fire("Error", "Vehicle Type ID is missing.", "error");
        return;
      }

      // =================================================
      // PREPARE REQUEST DATA
      // =================================================
      const payload = {
        company: update_modal_data.company,

        vehiclename: update_modal_data.vehiclename,

        vehicle_type: update_modal_data.vehicle_type,

        vehicleCategory: update_modal_data.vehicleCategory || "",

        feet:
          update_modal_data.feet !== "" ? Number(update_modal_data.feet) : null,

        firstServiceKm:
          update_modal_data.firstServiceKm !== ""
            ? Number(update_modal_data.firstServiceKm)
            : null,

        firstServiceDays:
          update_modal_data.firstServiceDays !== ""
            ? Number(update_modal_data.firstServiceDays)
            : null,

        secondServiceKm:
          update_modal_data.secondServiceKm !== ""
            ? Number(update_modal_data.secondServiceKm)
            : null,

        secondServiceDays:
          update_modal_data.secondServiceDays !== ""
            ? Number(update_modal_data.secondServiceDays)
            : null,

        thirdServiceKm:
          update_modal_data.thirdServiceKm !== ""
            ? Number(update_modal_data.thirdServiceKm)
            : null,

        thirdServiceDays:
          update_modal_data.thirdServiceDays !== ""
            ? Number(update_modal_data.thirdServiceDays)
            : null,

        fixedServiceKm:
          update_modal_data.fixedServiceKm !== ""
            ? Number(update_modal_data.fixedServiceKm)
            : null,

        fixedServiceDays:
          update_modal_data.fixedServiceDays !== ""
            ? Number(update_modal_data.fixedServiceDays)
            : null,

        battery:
          update_modal_data.battery !== ""
            ? Number(update_modal_data.battery)
            : null,

        amount:
          update_modal_data.amount !== ""
            ? Number(update_modal_data.amount)
            : null,

        // =================================================
        // OEM DETAILS
        // =================================================
        oemDetails: update_modal_data.oemDetails.map((oem) => {
          const oemData = {
            name: oem.name,
            contact: oem.contact,
            email: oem.email,
          };

          // Keep existing MongoDB OEM _id
          if (oem._id) {
            oemData._id = oem._id;
          }

          return oemData;
        }),
      };

      console.log("UPDATE PAYLOAD:", payload);

      // =================================================
      // API REQUEST
      // =================================================
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/vehicle-types/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      console.log("UPDATE RESPONSE:", response.data);

      if (response.data.success || response.status === 200) {
        Swal.fire(
          "Update Success",
          "Vehicle type updated successfully.",
          "success",
        );

        // Update parent/list
        if (onUpdateType) {
          onUpdateType(
            response.data.data || {
              ...update_modal_data,
              ...payload,
            },
          );
        }

        // Close modal
        set_update_data_modal_Show(false);
      } else {
        Swal.fire(
          "Update Failed",
          response.data.message || "Unable to update vehicle type.",
          "error",
        );
      }
    } catch (error) {
      console.error("Error updating vehicle type:", error);

      console.error("Server response:", error.response?.data);

      Swal.fire(
        "Update Failed",
        error.response?.data?.message ||
          "Something went wrong while updating vehicle type.",
        "error",
      );
    }
  };

  // =====================================================
  // RETURN
  // =====================================================
  return (
    <Modal show={add_data_modal_Show} onHide={handleClose} size="xl" centered>
      {/* =================================================
          MODAL HEADER
      ================================================= */}
      <Modal.Header closeButton>
        <Modal.Title>Update Vehicle Type</Modal.Title>
      </Modal.Header>

      {/* =================================================
          MODAL BODY
      ================================================= */}
      <Modal.Body>
        {/* =================================================
            VEHICLE DETAILS
        ================================================= */}
        <h5 className="mb-3">Vehicle Details</h5>

        <Row>
          {/* COMPANY */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                Company <span className="text-danger">*</span>
              </Form.Label>

              <Form.Control
                type="text"
                name="company"
                value={update_modal_data.company || ""}
                onChange={handleChange}
                placeholder="Enter Company"
                isInvalid={!!errors.company}
              />

              {errors.company && (
                <Form.Control.Feedback type="invalid">
                  {errors.company}
                </Form.Control.Feedback>
              )}
            </Form.Group>
          </Col>

          {/* VEHICLE TYPE */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                Vehicle Type <span className="text-danger">*</span>
              </Form.Label>

              <Form.Select
                name="vehiclename"
                value={update_modal_data.vehiclename || ""}
                onChange={handleChange}
                isInvalid={!!errors.vehiclename}
              >
                <option value="">Select Vehicle Type</option>
                <option value="Closed">Closed</option>
                <option value="Open">Open</option>
              </Form.Select>
              {errors.vehiclename && (
                <Form.Control.Feedback type="invalid">
                  {errors.vehiclename}
                </Form.Control.Feedback>
              )}
            </Form.Group>
          </Col>

          {/* WHEELER TYPE */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                Wheeler Type <span className="text-danger">*</span>
              </Form.Label>

              <Form.Select
                name="vehicle_type"
                value={update_modal_data.vehicle_type || ""}
                onChange={handleChange}
                isInvalid={!!errors.vehicle_type}
              >
                <option value="">Select Wheeler Type</option>

                <option value="2W">2W</option>

                <option value="3W">3W</option>

                <option value="4W">4W</option>
              </Form.Select>

              {errors.vehicle_type && (
                <Form.Control.Feedback type="invalid">
                  {errors.vehicle_type}
                </Form.Control.Feedback>
              )}
            </Form.Group>
          </Col>

          {/* VEHICLE CATEGORY */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Vehicle Category</Form.Label>

              <Form.Select
                name="vehicleCategory"
                value={update_modal_data.vehicleCategory || ""}
                onChange={handleChange}
              >
                <option value="">Select Vehicle Category</option>

                <option value="Ev">EV</option>

                <option value="Diesel">Diesel</option>

                <option value="Cng">CNG</option>

                <option value="Petrol">Petrol</option>
              </Form.Select>
            </Form.Group>
          </Col>

          {/* SERVICE INTERVAL KM */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>First Service Interval Km</Form.Label>

              <Form.Control
                type="number"
                name="firstServiceKm"
                value={update_modal_data.firstServiceKm ?? ""}
                onChange={handleChange}
                placeholder="Enter First Service Interval Km"
              />
            </Form.Group>
          </Col>

          {/* SERVICE INTERVAL DAYS */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>First Service Interval Days</Form.Label>

              <Form.Control
                type="number"
                name="firstServiceDays"
                value={update_modal_data.firstServiceDays ?? ""}
                onChange={handleChange}
                placeholder="Enter First Service Interval Days"
              />
            </Form.Group>
          </Col>

          {/* SERVICE INTERVAL KM */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Second Service Interval Km</Form.Label>

              <Form.Control
                type="number"
                name="secondServiceKm"
                value={update_modal_data.secondServiceKm ?? ""}
                onChange={handleChange}
                placeholder="Enter Second Service Interval Km"
              />
            </Form.Group>
          </Col>

          {/* SERVICE INTERVAL DAYS */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Second Service Interval Days</Form.Label>

              <Form.Control
                type="number"
                name="secondServiceDays"
                value={update_modal_data.secondServiceDays ?? ""}
                onChange={handleChange}
                placeholder="Enter Second Service Interval Days"
              />
            </Form.Group>
          </Col>

          {/* SERVICE INTERVAL KM */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Third Service Interval Km</Form.Label>

              <Form.Control
                type="number"
                name="thirdServiceKm"
                value={update_modal_data.thirdServiceKm ?? ""}
                onChange={handleChange}
                placeholder="Enter Third Service Interval Km"
              />
            </Form.Group>
          </Col>

          {/* SERVICE INTERVAL DAYS */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Third Service Interval Days</Form.Label>

              <Form.Control
                type="number"
                name="thirdServiceDays"
                value={update_modal_data.thirdServiceDays ?? ""}
                onChange={handleChange}
                placeholder="Enter Third Service Interval Days"
              />
            </Form.Group>
          </Col>

          {/* SERVICE INTERVAL KM */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Fixed Service Interval Km</Form.Label>

              <Form.Control
                type="number"
                name="fixedServiceKm"
                value={update_modal_data.fixedServiceKm ?? ""}
                onChange={handleChange}
                placeholder="Enter Fixed Service Interval Km"
              />
            </Form.Group>
          </Col>

          {/* SERVICE INTERVAL DAYS */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Fixed Service Interval Days</Form.Label>

              <Form.Control
                type="number"
                name="fixedServiceDays"
                value={update_modal_data.fixedServiceDays ?? ""}
                onChange={handleChange}
                placeholder="Enter Fixed Service Interval Days"
              />
            </Form.Group>
          </Col>

          {/* VEHICLE FEET */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Vehicle Feet</Form.Label>

              <Form.Select
                name="feet"
                value={update_modal_data.feet ?? ""}
                onChange={handleChange}
              >
                <option value="">Select Vehicle Feet</option>
                <option value="7">7 ft</option>
                <option value="8">8 ft</option>
                <option value="10">10 ft</option>
                <option value="12">12 ft</option>
                <option value="14">14 ft</option>
                <option value="16">16 ft</option>
              </Form.Select>
            </Form.Group>
          </Col>

          {/* BATTERY */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Vehicle Battery (KWH)</Form.Label>

              <Form.Control
                type="number"
                name="battery"
                value={update_modal_data.battery ?? ""}
                onChange={handleChange}
                placeholder="Enter Vehicle Battery"
              />
            </Form.Group>
          </Col>

          {/* AMOUNT */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Amount (Per Unit)</Form.Label>

              <Form.Control
                type="number"
                name="amount"
                value={update_modal_data.amount ?? ""}
                onChange={handleChange}
                placeholder="Enter Per Unit Amount"
              />
            </Form.Group>
          </Col>
        </Row>

        {/* =================================================
            OEM DETAILS
        ================================================= */}
        <hr className="my-4" />

        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h5 className="mb-1">OEM Details</h5>

            <small className="text-muted">Add or update OEM information</small>
          </div>

          <Button type="button" variant="success" size="sm" onClick={addOEM}>
            + Add OEM
          </Button>
        </div>

        {/* OEM TABLE */}
        {update_modal_data.oemDetails &&
        update_modal_data.oemDetails.length > 0 ? (
          <div className="table-responsive">
            <Table bordered hover responsive className="align-middle">
              <thead className="table-light">
                <tr>
                  <th style={{ width: "5%" }}>#</th>

                  <th style={{ width: "27%" }}>OEM Name</th>

                  <th style={{ width: "23%" }}>Contact</th>

                  <th style={{ width: "30%" }}>Email</th>

                  <th style={{ width: "15%" }} className="text-center">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {update_modal_data.oemDetails.map((oem, index) => (
                  <tr key={oem._id || `new-oem-${index}`}>
                    {/* NUMBER */}
                    <td>{index + 1}</td>

                    {/* OEM NAME */}
                    <td>
                      <Form.Control
                        type="text"
                        name="name"
                        size="sm"
                        value={oem.name || ""}
                        onChange={(e) => handleOEMChange(index, e)}
                        placeholder="OEM Name"
                        isInvalid={!!errors[`oem_${index}_name`]}
                      />

                      {errors[`oem_${index}_name`] && (
                        <small className="text-danger">
                          {errors[`oem_${index}_name`]}
                        </small>
                      )}
                    </td>

                    {/* CONTACT */}
                    <td>
                      <Form.Control
                        type="text"
                        name="contact"
                        size="sm"
                        value={oem.contact || ""}
                        onChange={(e) => handleOEMChange(index, e)}
                        placeholder="Contact Number"
                        isInvalid={!!errors[`oem_${index}_contact`]}
                      />

                      {errors[`oem_${index}_contact`] && (
                        <small className="text-danger">
                          {errors[`oem_${index}_contact`]}
                        </small>
                      )}
                    </td>

                    {/* EMAIL */}
                    <td>
                      <Form.Control
                        type="email"
                        name="email"
                        size="sm"
                        value={oem.email || ""}
                        onChange={(e) => handleOEMChange(index, e)}
                        placeholder="OEM Email"
                        isInvalid={!!errors[`oem_${index}_email`]}
                      />

                      {errors[`oem_${index}_email`] && (
                        <small className="text-danger">
                          {errors[`oem_${index}_email`]}
                        </small>
                      )}
                    </td>

                    {/* REMOVE */}
                    <td className="text-center">
                      <Button
                        type="button"
                        variant="outline-danger"
                        size="sm"
                        onClick={() => removeOEM(index)}
                      >
                        Remove
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <div className="border rounded p-4 text-center">
            <p className="text-muted mb-3">No OEM details added.</p>

            <Button
              type="button"
              variant="outline-success"
              size="sm"
              onClick={addOEM}
            >
              + Add OEM
            </Button>
          </div>
        )}
      </Modal.Body>

      {/* =================================================
          MODAL FOOTER
      ================================================= */}
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>

        <Button variant="primary" size="sm" onClick={handleUpdate}>
          Update Type
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
